<template>
  <div class="search-screen">
    <h4 class="cnpj-section-title">PESQUISA GOOGLE</h4>
    <p class="cnpj-section-subtitle">
      Insira aqui as informações para buscar pelo google
    </p>
    <div class="search-google-fields">
      <div class="input-group-google search-combo">
        <input
          id="searchTerm"
          v-model="searchTerm"
          type="text"
          placeholder="Busque aqui por: Ex: Borracharia"
          class="search-input-google"
          @keyup.enter="searchGoogle"
        />
        <button type="button" class="icon_search_google" @click="searchGoogle">
          <svg
            width="18"
            height="18"
            viewBox="0 0 20 21"
            fill="none"
            class="menu-item-icon"
            aria-hidden="true"
          >
            <path
              d="M19.5293 17.1318C19.8773 17.5186 19.8773 18.0986 19.4906 18.4467L18.4078 19.5295C18.0598 19.9162 17.4797 19.9162 17.093 19.5295L13.2645 15.701C13.0711 15.5076 12.9937 15.2756 12.9937 15.0436V14.3861C11.6016 15.4689 9.9 16.0877 8.04375 16.0877C3.59648 16.0877 -9.53674e-07 12.4912 -9.53674e-07 8.04394C-9.53674e-07 3.63535 3.59648 0.000194311 8.04375 0.000194311C12.4523 0.000194311 16.0875 3.63535 16.0875 8.04394C16.0875 9.93887 15.4301 11.6404 14.3859 12.9939H15.0047C15.2367 12.9939 15.4687 13.11 15.6621 13.2646L19.5293 17.1318ZM8.04375 12.9939C10.7508 12.9939 12.9937 10.7896 12.9937 8.04394C12.9937 5.33691 10.7508 3.09394 8.04375 3.09394C5.29805 3.09394 3.09375 5.33691 3.09375 8.04394C3.09375 10.7896 5.29805 12.9939 8.04375 12.9939Z"
              fill="white"
            />
          </svg>
          <span>Buscar</span>
        </button>
      </div>

      <div class="input-group-google">
        <input
          v-model="searchCep"
          type="text"
          placeholder="Busque aqui por: CEP (opcional)"
          class="search-input-google"
          @keyup.enter="searchGoogle"
        />
      </div>

      <div class="input-group-googlep input-group-googlep--readonly" style="color: #aaaaaa;">
        <input
          v-model="radiusDisplay"
          type="text"
          placeholder="Distancia de busca é de 5 km"
          class="search-input-google search-input-google--readonly"
          readonly
          tabindex="-1"
          aria-readonly="true"
          @mousedown.prevent
          @click.prevent
          @keydown.prevent
        />
      </div>
    </div>

    <p v-if="googleResults.length >= 50" class="search-note">
      * Limite de até 60 resultados por pesquisa Google.
    </p>

    <div class="table-wrapper">
      <div class="tableContainer">
        <table class="tableClient">
          <thead>
            <tr>
              <th>NOME</th>
              <th>ENDEREÇO</th>
              <th>TELEFONE</th>
              <th v-if="isWhatsConnected">WHATSAPP</th>
              <th>WEBSITE</th>
            </tr>
          </thead>
          <tbody v-if="googleResults.length">
            <tr v-for="(result, index) in paginatedResults" :key="index">
              <td>{{ result.name }}</td>
              <td>{{ result.address }}</td>
              <td>{{ result.phone }}</td>
              <td v-if="isWhatsConnected">
                <span v-if="result.hasWhatsApp === 'valid'">✅</span>
                <span v-else-if="result.hasWhatsApp === 'invalid'">❌</span>
                <span v-else-if="result.hasWhatsApp === 'unavailable'">📴</span>
              </td>
              <td>
                <a
                  v-if="result.website !== 'Não disponível'"
                  :href="result.website"
                  target="_blank"
                >
                  {{ result.website }}
                </a>
                <span v-else>{{ result.website }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="loading" class="loading-container">
        <div class="loading-bar"></div>
        <p>Carregando resultados...</p>
      </div>

      <p v-else-if="!googleResults.length && !loading">
        Sem resultados para a pesquisa.
      </p>
    </div>

    <!-- 🔹 Controles de Paginação e Ações -->
    <div class="pagination-container">
      <p class="record-count">Total de registros: {{ googleResults.length }}</p>
      <div class="pagination">
        <span class="page-label">Páginas:</span>

        <button
          class="pagination-button"
          @click="previousPage"
          :disabled="currentPage === 1"
        >
          «
        </button>

        <span class="page-current">{{ currentPage }}</span>

        <button
          class="pagination-button"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          »
        </button>

        <span class="page-info"> {{ currentPage }} de {{ totalPages }} </span>
      </div>
    </div>

    <div class="export-container">
      <button class="small-button" @click="exportGoogleCSV">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.9974 9.07464H9.07073V4.0013H15.9974V9.58797H17.3307V4.0013C17.3307 3.64768 17.1903 3.30854 16.9402 3.05849C16.6902 2.80844 16.351 2.66797 15.9974 2.66797H7.24406L2.66406 7.24797V20.0013C2.66406 20.3549 2.80454 20.6941 3.05459 20.9441C3.30464 21.1942 3.64377 21.3346 3.9974 21.3346H15.9974C16.351 21.3346 16.6902 21.1942 16.9402 20.9441C17.1903 20.6941 17.3307 20.3549 17.3307 20.0013H3.9974V9.07464ZM3.9974 7.79463L7.79073 4.0013H7.9974V8.0013H3.9974V7.79463Z"
            fill="#4D5163"
          />
          <path
            d="M18.8826 10.8986C18.7551 10.7894 18.591 10.7323 18.4232 10.7388C18.2555 10.7453 18.0963 10.8148 17.9776 10.9335C17.8588 11.0523 17.7893 11.2114 17.7828 11.3792C17.7763 11.547 17.8334 11.7111 17.9426 11.8386L20.1093 13.9986H12.0026C11.8258 13.9986 11.6562 14.0688 11.5312 14.1938C11.4062 14.3189 11.3359 14.4884 11.3359 14.6653C11.3359 14.8421 11.4062 15.0116 11.5312 15.1367C11.6562 15.2617 11.8258 15.3319 12.0026 15.3319H20.1293L17.9426 17.5186C17.8728 17.5784 17.8161 17.6519 17.7761 17.7346C17.7361 17.8173 17.7136 17.9074 17.7101 17.9992C17.7065 18.091 17.722 18.1826 17.7555 18.2681C17.789 18.3537 17.8399 18.4314 17.9048 18.4964C17.9698 18.5613 18.0475 18.6122 18.1331 18.6457C18.2186 18.6792 18.3102 18.6947 18.402 18.6911C18.4938 18.6876 18.5839 18.6651 18.6666 18.6251C18.7493 18.5851 18.8228 18.5284 18.8826 18.4586L22.6693 14.6653L18.8826 10.8986Z"
            fill="#4D5163"
          />
        </svg>
        Exportar CSV
      </button>
      <button class="small-button" @click="prepareGoogleForSending">
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.0676 5.31937C22.447 2.69721 18.962 1.25159 15.2492 1.25C7.59605 1.25 1.36941 7.47346 1.36781 15.1234C1.36463 17.5577 2.00306 19.9506 3.21941 22.0601L1.25 29.25L8.60862 27.3204C10.6449 28.4285 12.9248 29.0096 15.2428 29.0096H15.2492C22.8992 29.0096 29.1258 22.7845 29.129 15.1346C29.1306 11.4282 27.6882 7.94313 25.0676 5.31937Z"
            stroke="#4D5163"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6594 16.1943C12.7912 15.2296 12.1367 14.1495 11.7018 13.0538C11.6098 12.8221 11.6639 12.5508 11.825 12.3719L12.4328 11.6975C12.9307 11.1442 12.9307 10.3618 12.4958 9.87864L11.6246 8.91068C11.045 8.26675 10.1056 8.26675 9.52599 8.91068L9.04215 9.44825C8.49226 10.0592 8.26295 10.9406 8.41137 11.8146C8.77796 13.969 9.90445 16.3278 11.7218 18.347C13.5392 20.3662 15.6623 21.6178 17.6014 22.0251C18.388 22.19 19.1813 21.9352 19.7312 21.3243L20.2143 20.7875C20.7939 20.1436 20.7939 19.0998 20.2143 18.4559L19.3438 17.4887C18.909 17.0056 18.204 17.0056 17.7699 17.4887L17.0998 18.2341C16.9387 18.413 16.6946 18.4732 16.486 18.3709C15.4998 17.887 14.5277 17.1589 13.6594 16.1943Z"
            fill="#4D5163"
          />
        </svg>
        Enviar Mensagem
      </button>
    </div>
  </div>
</template>

<script>
//import { getAuth } from "firebase/auth";
import { secureFetch } from "@/main.js";

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://177.36.4.221:3000";

export default {
  name: "GoogleSearch",
  data() {
    return {
      searchTerm: "",
      searchCep: "",
      radius: 5000,
      googleResults: [],
      currentPage: 1,
      resultsPerPage: 10,
      loading: false,
      userLocation: null, // string "lat,lng"
      currentLocation: null, // objeto { lat, lng }
      userCep: "",
      userCidade: "",
      userEstado: "",
      isWhatsConnected: localStorage.getItem("qrActive") === "true",
    };
  },
  mounted() {
    // 🔄 Atualiza automaticamente caso o status mude no storage
    window.addEventListener("storage", (e) => {
      if (e.key === "qrActive") {
        this.isWhatsConnected = e.newValue === "true";
      }
    });
  },
  computed: {
    // Calcula o total de páginas com base no número de registros e a quantidade por página
    totalPages() {
      return Math.ceil(this.googleResults.length / this.resultsPerPage);
    },

    // Filtra os resultados para exibir apenas os da página atual
    paginatedResults() {
      const start = (this.currentPage - 1) * this.resultsPerPage;
      const end = start + this.resultsPerPage;
      return this.googleResults.slice(start, end);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    async searchGoogle() {
      if (!this.searchTerm) {
        alert("Por favor, forneça um termo de pesquisa.");
        return;
      }

      if (this.searchCep) {
        const cepClean = this.searchCep.replace(/\D/g, "");
        if (cepClean.length !== 8) {
          alert("Digite um CEP válido com 8 dígitos.");
          return;
        }
        const locationFromCep = await this.getCoordinatesFromCep(cepClean);
        if (!locationFromCep) {
          alert("Não foi possível localizar o CEP informado.");
          return;
        }
        this.userLocation = `${locationFromCep.lat},${locationFromCep.lng}`;
      } else {
        if (!this.userLocation || !this.userLocation.includes(",")) {
          console.warn("⚠️ Localização inválida. Usando padrão Recife.");
          this.userLocation = "-8.05428,-34.8813";
        }
      }

      this.loading = true;

      try {
        // 🧹 Limpa a tabela imediatamente ao iniciar a nova busca
        this.googleResults = [];

        const response = await secureFetch(
          `${apiBaseUrl}/search-google?query=${encodeURIComponent(
            this.searchTerm
          )}&location=${this.userLocation}&radius=${
            parseInt(this.radius) || 5000
          }`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Verificando se a resposta foi bem-sucedida
        if (!response.ok) {
          throw new Error("Falha ao conectar com o backend");
        }

        // Parsing da resposta da API
        const data = await response.json();
        console.log("📦 Dados recebidos do backend:", data);
        const whatsConnected = this.isWhatsConnected;
        console.log("🔎 Status WhatsApp conectado:", whatsConnected);

        const enrichedResults = await Promise.all(
          data.map(async (result) => {
            if (!whatsConnected) {
              return { ...result, hasWhatsApp: null };
            }

            let hasWhatsApp = "invalid";
            if (result.phone && /\d{10,}/.test(result.phone)) {
              hasWhatsApp = await this.ChecaWhats(result.phone);
            }

            return { ...result, hasWhatsApp };
          })
        );

        this.googleResults = enrichedResults;
      } catch (error) {
        console.error("Erro ao buscar resultados no Google:", error);
        alert("Erro ao buscar resultados. Tente novamente.");
      } finally {
        this.loading = false;
      }
    },
    async getCoordinatesFromCep(cep) {
      try {
        const response = await secureFetch(
          `${apiBaseUrl}/get-coordinates?cep=${cep}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Erro ao buscar coordenadas do CEP");

        const data = await response.json();
        if (data.success && data.location) {
          return data.location;
        }

        throw new Error(data.message || "Erro desconhecido ao obter CEP");
      } catch (error) {
        console.error("❌ Erro ao buscar coordenadas do CEP:", error);
        return null;
      }
    },
    async getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            if (!isNaN(latitude) && !isNaN(longitude)) {
              this.currentLocation = { lat: latitude, lng: longitude };
              this.userLocation = `${latitude},${longitude}`;
              console.log(`📍 Localização obtida: ${latitude}, ${longitude}`);

              await this.getAddressFromCoords(latitude, longitude);
            } else {
              console.error(
                "⚠️ Coordenadas inválidas obtidas da geolocalização."
              );
              alert(
                "Não foi possível determinar sua localização. Digite um CEP para continuar."
              );
            }
          },
          (error) => {
            console.error("Erro ao obter localização:", error);
            alert(
              "Não foi possível obter sua localização. Digite um CEP para continuar."
            );
          }
        );
      } else {
        alert(
          "Seu navegador não suporta geolocalização. Digite um CEP para continuar."
        );
      }
    },
    async getAddressFromCoords(lat, lng) {
      if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
        console.error("⚠️ Coordenadas inválidas para buscar endereço.");
        return;
      }
      try {

        // 🔥 Faz a requisição para o backend buscar o endereço a partir das coordenadas
        const response = await secureFetch(
          //`http://localhost:3000/get-address?lat=${lat}&lng=${lng}`,
          `${apiBaseUrl}/get-address?lat=${lat}&lng=${lng}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.success && data.address) {
          console.log(
            `📍 Endereço encontrado para ${lat}, ${lng}:`,
            data.address
          );
          this.userCep = data.address.cep;
          this.userCidade = data.address.cidade;
          this.userEstado = data.address.estado;
        } else {
          throw new Error(
            data.message || "Erro ao processar a resposta do backend"
          );
        }
      } catch (error) {
        console.error("❌ Erro ao buscar endereço:", error);
        this.userCidade = "Localização aproximada";
        this.userEstado = "N/A";
      }
    },
    // 🔹 Verifica se o número tem WhatsApp chamando o backend
    async ChecaWhats(phoneNumber) {
      if (!this.isWhatsConnected) {
        console.warn("📴 WhatsApp não conectado — pulando verificação.");
        return "unavailable";
      }
      try {
        // 🔹 Valida o número antes de prosseguir
        if (!phoneNumber || phoneNumber === "Telefone não disponível") {
          console.warn(
            "📵 Número inválido ou indisponível. Pulando verificação de WhatsApp."
          );
          return "invalid";
        }

        // 🔹 Remove tudo que não for número
        const cleanNumber = phoneNumber.replace(/\D/g, "");
        if (!cleanNumber || cleanNumber.length < 10) {
          console.warn(`📞 Número muito curto ou inválido: ${phoneNumber}`);
          return "invalid";
        }

        // 🔹 Monta o número formatado no padrão internacional (sem '+')
        const formattedNumber = cleanNumber.startsWith("55")
          ? cleanNumber
          : `55${cleanNumber}`;

        console.log(`📞 Verificando número no WhatsApp: ${formattedNumber}`);

        const url = `${apiBaseUrl}/check-whatsapp?telefoneVendedor=${formattedNumber}`;
        
        const response = await secureFetch(
          url,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 503) {
          console.warn("📴 Cliente WhatsApp não conectado.");
          return "unavailable";
        }

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        console.log("🔎 API WhatsApp Response: ", result);

        return result.valid ? "valid" : "invalid";
      } catch (error) {
        console.error("❌ Erro ao verificar número no WhatsApp:", error);
        return "invalid";
      }
    },
    // Exporta resultados da pesquisa Google para CSV
    exportGoogleCSV() {
      try {
        if (!this.googleResults || this.googleResults.length === 0) {
          alert("Nenhum dado para exportar.");
          return;
        }

        const headers = ["Nome", "Endereço", "Telefone", "WhatsApp", "Website"];

        // helper para normalizar e escapar campos
        const fmt = (v) =>
          `"${String(v ?? "")
            .normalize("NFC") // corrige acentos “quebrados”
            .replace(/"/g, '""') // escapa aspas
            .replace(/;/g, ",")}"`; // evita conflito com separador ;

        const rows = [
          headers.join(";"),
          ...this.googleResults.map((result) => {
            const hasWhats =
              result.hasWhatsApp === "valid"
                ? "✅"
                : result.hasWhatsApp === "invalid"
                ? "❌"
                : result.hasWhatsApp === "unavailable"
                ? "📴"
                : "";

            return [
              fmt(result.name || ""),
              fmt(result.address || ""),
              fmt(result.phone || ""),
              fmt(hasWhats),
              fmt(result.website || ""),
            ].join(";");
          }),
        ];

        const BOM = "\uFEFF"; // garante UTF-8 reconhecido pelo Excel
        const csvContent = BOM + rows.join("\r\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "pesquisa_google.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log("✅ CSV exportado com sucesso.");
      } catch (error) {
        console.error("❌ Erro ao exportar CSV:", error);
        alert("Erro ao exportar CSV. Verifique o console para detalhes.");
      }
    },
    prepareGoogleForSending() {
      const contactsToSend = this.googleResults
        .filter((result) => {
          const phone = (result.phone || "").replace(/\D/g, ""); // normaliza o número
          if (!phone || phone.startsWith("0800") || phone.length < 10) {
            console.warn(`📞 Ignorando número inválido: ${result.phone}`);
            return false;
          }
          return true;
        })
        .map((result) => ({
          name: result.name?.trim() || "Sem nome",
          number: (result.phone || "").replace(/\D/g, ""),
        }));

      if (contactsToSend.length === 0) {
        alert("Nenhum contato válido encontrado para envio!");
        return;
      }

      // 🔹 Remove duplicados com base no número
      const uniqueContacts = Array.from(
        new Map(contactsToSend.map((c) => [c.number, c])).values()
      );

      console.log(
        `📤 Emitindo ${uniqueContacts.length} contatos únicos (removidos ${
          contactsToSend.length - uniqueContacts.length
        } duplicados)`
      );

      this.$emit("prepare-send", uniqueContacts);
    },
  },
};
</script>

<style src="@/assets/styles.css"></style>
